import { Author } from '../../models/result-set';
import { AuthorChip } from './AuthorChip';
import { CorpusId } from '../../models/aliases';

import { Stack } from '@mui/material';
import { useState } from 'react';
import styled from 'styled-components';

interface PaperAuthorsProps {
  authors: Array<Author>;
  corpusId: CorpusId;
  authorLimit?: number;
  shortenAuthorNames?: boolean;
}

export function PaperAuthors(props: PaperAuthorsProps): JSX.Element {
  const {
    authors,
    corpusId,
    authorLimit = 3,
    shortenAuthorNames = true,
  } = props;
  const [showAllAuthors, setShowAllAuthors] = useState<boolean>(false);

  if (authors.length === 0) {
    return <AuthorsStack />;
  }

  const showLastAuthor = authorLimit > 1;
  const authorsEnd = showAllAuthors
    ? authors.length
    : showLastAuthor && authorLimit !== authors.length
    ? authorLimit - 1
    : authorLimit;
  const lastAuthor = authors[authors.length - 1];

  return (
    <AuthorsStack>
      {authors.slice(0, authorsEnd).map((a: Author, i: number) => (
        <AuthorChip
          key={`${i}-${a.name}`}
          corpusId={corpusId}
          chipContent={a.name}
          authorId={a.id}
          shorten={shortenAuthorNames}
        ></AuthorChip>
      ))}
      {authors.length > authorLimit && (
        <>
          {/* Expand/Collapse button */}
          <AuthorChip
            key={`show-more-${authors.length}`}
            corpusId={corpusId}
            chipContent={
              showAllAuthors ? (
                <>&#8863; less</>
              ) : (
                `+${
                  authors.length - authorsEnd - (showLastAuthor ? 1 : 0)
                } authors`
              )
            }
            onClick={() => {
              setShowAllAuthors(!showAllAuthors);
            }}
          ></AuthorChip>
          {/* always render the last author, as that is usually the Principal Investigator */}
          {!showAllAuthors && authorLimit > 1 && (
            <AuthorChip
              key={`${authors.length - 1}-${lastAuthor.name}`}
              corpusId={corpusId}
              chipContent={lastAuthor.name}
              authorId={lastAuthor.id}
              shorten={shortenAuthorNames}
            ></AuthorChip>
          )}
        </>
      )}
    </AuthorsStack>
  );
}

const AuthorsStack = styled(Stack).attrs({
  direction: 'row',
  flexWrap: 'wrap',
  gap: 0.5,
  alignItems: 'center',
})``;
